import { animaAbi } from "../assets/abis/animaAbi";
import { erc1155abi } from "../assets/abis/erc1155abi";
import { gumballAbi } from "../assets/abis/gumballAbi";
import { BigNumber } from "ethers";

function getSetApprovalDef(address, operator, amount) {
    const setApprovalDef = {
        address: address,
        abi: animaAbi,
        functionName: "approve",
        args: [operator, amount],
        enabled: true,
    };

    return setApprovalDef;
}

function getSetBurnableApprovalDef(address, operator) {
    const setApprovalDef = {
        address: address,
        abi: erc1155abi,
        functionName: "setApprovalForAll",
        args: [operator, true],
        enabled: true,
    };

    return setApprovalDef;
}

function getGumballDef(address, ready) {
    //console.log(`getGumballDef: ready: ${ready}`);

    const setGumballDef = {
        address: address,
        abi: gumballAbi,
        functionName: "animaGacha",
        enabled: ready,
    };

    return setGumballDef;
}

function getMaticGumballDef(address, cost, ready) {
    const value = BigNumber.from(cost.toString());

    const setMaticGumballDef = {
        address: address,
        abi: gumballAbi,
        functionName: "maticGacha",
        enabled: ready,
        overrides: {
            value: value.toString(),
        },
    };

    return setMaticGumballDef;
}

function getBurnableGumballDef(address, tokenId, ready) {
    //console.log(`getBurnableGumballDef ready: ${ready}`);

    const setMaticGumballDef = {
        address: address,
        abi: gumballAbi,
        functionName: "burnableForGacha",
        args: [tokenId],
        enabled: ready,
    };

    return setMaticGumballDef;
}

export {
    getSetApprovalDef,
    getSetBurnableApprovalDef,
    getGumballDef,
    getMaticGumballDef,
    getBurnableGumballDef,
};
